import { ApiService } from './api';

// API service instance
const apiService = ApiService.getInstance();

export interface ItemResponse {
    item_id: string;
    titulo: string;
    descricao: string;
    item_base_id: string;
    statusType: string;
    score: number;
    total_acoes: number;
}

export interface CriarItemRequest {
    titulo: string;
    descricao: string;
    responsavelId?: string;
}

export interface AtualizarItemRequest {
    titulo: string;
    descricao: string;
    usuarioResponsavelId?: string;
}

export const itemService = {
    // Get items for a specific question
    async getItemsByQuestion(questaoId: string): Promise<ItemResponse[]> {
        try {
            // Fetch data from the backend API
            const response: ItemResponse[] = await apiService.get(`/item/${questaoId}/usuario`);
            return response;
        } catch (error) {
            console.error('Error fetching items from API:', error);
            throw error;
        }
    },

    // Create a new item for a specific question
    async createItem(questaoId: string, request: CriarItemRequest): Promise<ItemResponse> {
        try {
            const response = await apiService.post<ItemResponse>(`/item/${questaoId}`, request);
            return response;
        } catch (error) {
            console.error('Error creating item:', error);
            throw error;
        }
    },

    // Update an existing item
    async updateItem(itemId: string, request: AtualizarItemRequest): Promise<ItemResponse> {
        try {
            const response = await apiService.put<ItemResponse>(`/item/${itemId}`, request);
            return response;
        } catch (error) {
            console.error('Error updating item:', error);
            throw error;
        }
    }
};
